import { useEffect, useRef, useState } from 'react';

/**
 * Çok-seviyeli gruplama seçici (sıralı checkbox listesi).
 * Props: value (string[]), onChange (next[]), options ({value,label}[]).
 */
export function MultiGroupPicker({ value, onChange, options }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const toggle = (v) => {
    if (value.includes(v)) onChange(value.filter((x) => x !== v));
    else onChange([...value, v]);
  };

  const isActive = value.length > 0;

  return (
    <span className="c360-multipick-wrap" ref={ref}>
      <button
        type="button"
        className={`c360-multipick-btn${isActive ? ' is-active' : ''}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        Grupla
        {isActive && <span className="c360-multipick-count">{value.length}</span>}
      </button>
      {open && (
        <div className="c360-multipick-popover" role="dialog" aria-label="Gruplama alanları">
          <div className="c360-multipick-title">Gruplama Sırası</div>
          {options.map((opt) => {
            const idx = value.indexOf(opt.value);
            return (
              <label key={opt.value} className="c360-multipick-item">
                <input type="checkbox" checked={idx !== -1} onChange={() => toggle(opt.value)} />
                <span>{opt.label}</span>
                {idx !== -1 && <span className="c360-multipick-item-order">{idx + 1}</span>}
              </label>
            );
          })}
          {value.length > 0 && (
            <div className="c360-multipick-actions">
              <button type="button" className="c360-multipick-link" onClick={() => onChange([])}>Tümünü temizle</button>
            </div>
          )}
        </div>
      )}
    </span>
  );
}
